import React, { useState } from 'react';
import styles from '../styles/ContactForm.module.css'; // Importing the CSS module
import { useForm, ValidationError } from '@formspree/react';

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const [state, handleSubmit] = useForm("xlderyog");

  return (
    <form className={styles.contactForm} onSubmit={handleSubmit}>
      <div className={styles.formGroup}>
        <label className={styles.label}>
          Name <span className={styles.requiredSpan}>(required)</span>
        </label>
        <div className={styles.nameInputs}>
          <div className={styles.firstName}>
            <label htmlFor="firstName" className={styles.nameLabel}>First Name</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              required
              value={formData.firstName}
              onChange={handleChange}
              className={styles.nameInput}
            />
          </div>
          <div className={styles.lastName}>
            <label htmlFor="lastName" className={styles.nameLabel}>Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              required
              value={formData.lastName}
              onChange={handleChange}
              className={styles.nameInput}
            />
          </div>
        </div>
      </div>

      <div className={styles.formGroup}>
        <label htmlFor="email" className={styles.label}>
          Email Address <span className={styles.requiredSpan}>(required)</span>
        </label>
        <input
          type="email"
          id="email"
          name="email"
          required
          value={formData.email}
          onChange={handleChange}
          className={styles.input}
        />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
      </div>

      <div className={styles.formGroup}>
        <label htmlFor="subject" className={styles.label}>
          Subject <span className={styles.requiredSpan}>(required)</span>
        </label>
        <input
          type="text"
          id="subject"
          name="subject"
          required
          value={formData.subject}
          onChange={handleChange}
          className={styles.input}
        />
      </div>

      <div className={styles.formGroup}>
        <label htmlFor="message" className={styles.label}>
          Message <span className={styles.requiredSpan}>(required)</span>
        </label>
        <textarea
          id="message"
          name="message"
          required
          value={formData.message}
          onChange={handleChange}
          className={styles.textarea}
        ></textarea>
      </div>

      {/* Success or error message feedback */}
      {state.succeeded && <p>Form submitted successfully!</p>}
      {state.errors && <p>There was an error submitting the form. Please try again.</p>}

      <button type="submit" className={styles.submitButton} disabled={state.submitting}>
        {state.submitting ? 'Sending...' : 'SUBMIT'}
      </button>

    </form>
  );
};

export default ContactForm;
